import React, { useContext, useState, useEffect } from "react";
import { Popover, List } from "antd/lib";
// Auth Context
import AuthContext from "../../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FetchUserImage from "../../components/FetchData/FetchUserImage";
import {
  onChangeEmployeePosition,
  toggleCollapsedSideNav,
} from "../../appRedux/actions";
import IntlMessages from "../../util/IntlMessages";

interface IUserProfile {
  direction: string;
  showUserName: boolean;
}

const UserProfile = ({ showUserName }: IUserProfile) => {
  let { navCollapsed } = useSelector(({ sideNav }: any) => sideNav);
  const [showMenu, setShowMenu] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const authContext = useContext(AuthContext);

  function changeHandler(item: any) {
    // userProfile
    if (authContext.setUserEmployeePosition) {
      // onChangeEmployeePosition
      authContext.setUserEmployeePosition(item);
      dispatch(onChangeEmployeePosition());
      dispatch(toggleCollapsedSideNav(!navCollapsed));
      setShowMenu(false);

      return history.push("/team-work/home");
    }
  }

  useEffect(() => {
    if (!navCollapsed) {
      setShowMenu(false);
    }
  }, [navCollapsed]);

  let userMenuOptions = (
    <List
      itemLayout="horizontal"
      dataSource={authContext.userRoles}
      renderItem={(item, index) => (
        <React.Fragment>
          <List.Item key={index} className="gx-pl-5" style={{ width: "242px" }}>
            <List.Item.Meta
              avatar={false}
              title={
                <span
                  onClick={() => changeHandler(item)}
                  className="gx-fs-sm gx-text-primary gx-pointer"
                >
                  {item.fullName}
                  {authContext.userEmployeePosition.personCode ===
                    item.personCode && (
                      <img
                        src={require("assets/images/LetterBody/tick.svg")}
                        alt="user-employee-position"
                        style={{ width: "14px" }}
                        className="gx-mx-2 gx-pointer"
                      />
                    )}
                </span>
              }
              description={
                <div onClick={() => changeHandler(item)} className="gx-pointer">
                  <span className="gx-text-orange"> [</span>
                  <span className="gx-fs-sm">{item.organizationName}</span>
                  <span className="gx-text-orange">] </span>
                </div>
              }
            />
          </List.Item>
        </React.Fragment>
      )}
      footer={
        <Link to="/auth/logout">
          <span className="gx-fs-sm">
            <IntlMessages id="topbar.Exit" />
          </span>
        </Link>
      }
    />
  );

  return (
    <div className="gx-flex-row gx-align-items-center gx-mb-9 gx-avatar-row">
      <Popover
        visible={showMenu}
        onVisibleChange={(val) => setShowMenu(val)}
        placement="bottomRight"
        title={false}
        content={userMenuOptions}
        trigger="click"
        className="gx-py-0 gx-w-100"
      >
        <span>
          <FetchUserImage
            src={`contactPicture/getContactPicture`}
            className="gx-bg-blue gx-mx-2 gx-size-40 fg-border-radius-100 gx-mr-2"
            alt=""
            text={
              showUserName && (
                <div className="gx-d-flex gx-flex-row gx-justify-content-between gx-align-items-center">
                  <div className="gx-align-content-center">
                    <div className="gx-text-grey">
                      {authContext.userEmployeePosition.name}
                    </div>
                    <div className="gx-text-orange">
                      {authContext.userEmployeePosition.departmentName}
                    </div>
                  </div>
                  <i className="icon icon-chevron-down gx-fs-xxs gx-ml-2 gx-mr-2" />
                </div>
              )
            }
          />
        </span>
      </Popover>
    </div>
  );
};

export default UserProfile;
